module.exports = __webpack_public_path__ + "static/media/pnlogo.56fcebb1.svg";